import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

async function bootstrap() {
  try {
    const res = await fetch('/config.json');

    if (!res.ok) throw new Error('Failed to load config');

    (window as any).APP_CONFIG = await res.json();
  } catch (err) {
    console.error('Config load failed:', err);
    (window as any).APP_CONFIG = {}; // fallback
  }

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    // <React.StrictMode>
      <App />
    // </React.StrictMode>
  );

  reportWebVitals();
}

bootstrap();